module.exports = __webpack_public_path__ + "static/media/level1_q1_wrong.821c4058.png";